import React from 'react';
import PropTypes from 'prop-types';
import BottomSheet from './bottom-sheet';
import Spacer from '../spacer';
import Text from '../text';
import Colors from '../colors';
import Button from '../button';
export default function Tip(props) {
  /*#__PURE__*/
  React.createElement(BottomSheet, null, /*#__PURE__*/React.createElement(Text.BodySmall, {
    color: Colors.gray600,
    weight: "medium"
  }, props.header), /*#__PURE__*/React.createElement(Spacer, {
    size: "f6",
    height: true
  }), /*#__PURE__*/React.createElement(Text.BodySmall, {
    color: Colors.gray500
  }, props.content), /*#__PURE__*/React.createElement(Spacer, {
    size: "f20",
    height: true
  }), /*#__PURE__*/React.createElement(Button, {
    type: "secondary",
    onPress: props.onPress
  }, props.button));
}
Tip.defaultProps = {
  header: 'Advance Credit Limit',
  content: 'This is your credit limit. You can advance up.....',
  onPress: () => {},
  button: 'Got it'
};
Tip.propTypes = {
  header: PropTypes.string,
  content: PropTypes.string,
  onPress: PropTypes.func,
  button: PropTypes.string
};
//# sourceMappingURL=tip.js.map